module.exports = __webpack_public_path__ + "assets/c8b50b8b6f37973e339392f26d05e46a.png";